import { Util } from './_util.js';
import videojs from 'video.js';
import MicroModal from 'micromodal';
import Cookies from 'js-cookie';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { Loader, LoaderOptions } from 'google-maps';

gsap.registerPlugin(ScrollTrigger, PixiPlugin);

const App = {
  sayHelloTest: function (fName) {
    console.log(`Hello, ${fName}`);
  },
  videoPlayerGate: function () {
    if (!document.body.contains(document.querySelector('#age-gate-video'))) return false;

    App.videoJSPlayer = videojs('age-gate-video', {
      autoplay: true,
      fill: true,
      loop: true,
      muted: true,
      poster: '/wp-content/uploads/2021/08/landing-page-bg.jpg',
    });

    App.videoJSPlayer.src({
      type: 'application/x-mpegURL',
      src: 'https://cdn.jwplayer.com/manifests/qM9lf47Z.m3u8',
    });
  },
  videoHomeLoop: function () {
    if (!document.body.contains(document.querySelector('#homepage-loop'))) return false;

    App.videoJSPlayer = videojs('homepage-loop', {
      autoplay: true,
      fill: true,
      loop: true,
      muted: true,
      poster: '/wp-content/uploads/2021/07/share-joy-video-bg.jpg',
    });

    App.videoJSPlayer.src({
      type: 'application/x-mpegURL',
      src: 'https://cdn.jwplayer.com/manifests/4puUc38p.m3u8',
    });
  },
  C7Clubv2: function () {
    let url = new URL(window.location);

    let currentUrl = document.location.href;
    let terms = `<div id='custom-terms' style='text-align: left;display: flex;flex-direction: column;'> 
    <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;
      font-size:15px;font-family:inherit,sans-serif;'> 
      <strong>AUTOMATIC RENEWAL TERMS</strong>
    </p> 
    <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;
      font-size:15px;font-family:inherit,sans-serif;'>
    By joining a Rombauer Vineyards' Wine Club, you consent to have your credit card automatically billed for upcoming shipments indefinitely until you cancel your membership with us. You will be notified in advance of each shipment and your credit card will be billed the amount of the shipment prior to its scheduled date. The current release schedules is as follows: Joy of Wine Club: three times per year; Joy of Chardonnay Club: three times per year; Joy of Zinfandel Club: twice per year; Joy of Cabernet Club: twice per year; Subscription: every 1, 2, or 3 months at your selection. We ask that each shipment includes a minimum number of bottles that varies by club and shipment date. Rombauer Vineyards reserves the right to change these shipment costs and other club benefits at any time.
    </p> 

    <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;
      font-size:15px;font-family:inherit,sans-serif;'> 
      <strong>MINIMUM PURCHASE REQUIREMENT AND CANCELLATION POLICY</strong>
    </p> 
    <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;
      font-size:15px;font-family:inherit,sans-serif;'>
      If you would like to cancel your membership, please contact us by phone at 866-280-2582 or by email at <a href='mailto:wineclub@rombauer.com'>wineclub@rombauer.com</a>. 
      Alternatively, you may cancel via the Club Memberships portal on your Account at Rombauer.com.
    </p> 
    <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;
      font-size:15px;font-family:inherit,sans-serif;'>
          I understand and agree to the above terms and confirm that I am over 21 years of age and 
          that a person 21 years or older must be available to sign for wine shipments upon delivery.
      </p>
    <div style='display: grid;grid-template-columns: 0fr 0.6fr;width: 200px;text-align: center;
      margin: 2rem auto;justify-content: center;'> 
      <input style='align-self: center;margin: auto .8rem;' type='checkbox' id='confirm-club-conditions' name='scales'>
      <label for='confirm-club-condition' style='align-self: center;'>OK with me</label>
    </div> 
  </div>`;

    function validate() {
      if ($('#confirm-club-conditions').length > 0) {
        let buttons = document.querySelectorAll('.c7-checkout__content form button[type="submit"]');
        if (document.getElementById('confirm-club-conditions').checked) {
          [...buttons].forEach((button) => {
            button.classList.remove('disable');
          });
        } else {
          [...buttons].forEach((button) => {
            button.classList.add('disable');
          });
        }
      }
    }

    $(document).on('click', '#confirm-club-conditions', function () {
      validate();
    }); //on click

    function appendTerms() {
      if ($('#confirm-club-conditions').length == 0) {
        $('.c7-notice.c7-notice--charge-date').append(terms);
        validate();
      }
    }

    if (url.pathname.includes('/club/')) {
      let intervalId = setInterval(function () {
        validate();
        // console.log('currentUrl top', currentUrl);
        if (document.location.href.includes('checkout/club/review')) {
          appendTerms();
        }

        if (document.location.href !== currentUrl) {
          // The URL has changed. You can use document.location to access the
          // current URL.
          if (document.location.href.includes('checkout/club/review')) {
            appendTerms();
          }
          currentUrl = document.location.href;
        }
      }, 1000); // Check every 500 milliseconds
    }

    validate();
  },
  C7Club: function () {
    $(window).on('load', function () {
      //pin r7 reso widget
      setTimeout(function () {
        function clubCheck() {
          function validate() {
            if ($('#confirm-club-conditions').length > 0) {
              if (document.getElementById('confirm-club-conditions').checked) {
                document.querySelector('button[type="submit"]').classList.remove('disable');
              } else {
                document.querySelector('button[type="submit"]').classList.add('disable');
              }
            }
          }

          let addTermsToClub = function () {
            let url = new URL(window.location);

            let terms =
              " <div id='custom-terms' style='text-align: left;display: flex;flex-direction: column;'> <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;font-size:15px;font-family:inherit,sans-serif;'> <strong>AUTOMATIC RENEWAL TERMS</strong></p> <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;font-size:15px;font-family:inherit,sans-serif;'>By joining a Rombauer Vineyards Wine Club, you consent to have your credit card automatically billed for upcoming shipments indefinitely until you cancel your membership with us. You will be notified in advance of each shipment and your credit card will be billed the amount of the shipment prior to its scheduled date. The current release schedules is as follows: Classic Club: three times per year; Chardonnay Club: three times per year; Zinfandel Club: twice per year; Dessert Club: twice per year; Cabernet Club: twice per year; Subscription: every 1, 2, or 3 months at your selection. We ask that each shipment includes a minimum number of bottles that varies by club and shipment date. Rombauer Vineyards reserves the right to change these shipment costs and other club benefits at any time.</p> <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;font-size:15px;font-family:inherit,sans-serif;'> <strong>MINIMUM PURCHASE REQUIREMENT AND CANCELLATION POLICY</strong></p> <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;line-height:107%;font-size:15px;font-family:inherit,sans-serif;'>Prior to cancellation, we ask that you receive at least two shipments. If you wish to cancel prior to the second shipment, an administrative fee of $50 will be charged for early termination. If you would like to cancel your membership, please contact us by phone at 866-280-2582 or by email at <a href='mailto:wineclub@rombauer.com'>wineclub@rombauer.com</a>. I understand and agree to the above terms and confirm that I am over 21 years of age and that a person 21 years or older must be available to sign for wine shipments upon delivery.</p> <div style='display: grid;grid-template-columns: 0fr 0.6fr;width: 200px;text-align: center;margin: 2rem auto;justify-content: center;'> <input style='align-self: center;margin: auto .8rem;' type='checkbox' id='confirm-club-conditions' name='scales'> <label for='confirm-club-condition' style='align-self: center;'>OK with me</label> </div> </div> ";

            if (url.pathname.includes('/club/')) {
              // let testClubCheckout = isValueInDatalayer('event', 'clubCheckout');
              console.log('clubCheckout');
              setTimeout(function () {
                window.dataLayer.forEach(function (element, index, array) {
                  console.log('element', element);
                  // if (index === array.length - 1) {
                  let url = element['gtm.newUrl'];

                  if (url !== undefined) {
                    if (url.indexOf('review') !== -1) {
                      $('.c7-notice.c7-notice--charge-date').append(terms);
                    }
                  }
                  // let step = element.club['checkout'].actionField.step;

                  //  if (document.body.contains(document.querySelector('#custom-terms'))) {
                  // if (step == 2) {
                  //   $('.c7-checkout__content__summary').append(terms);
                  //   console.log('step2', true);
                  // } else if (step == 4) {
                  //   $('.c7-checkout__content__summary').append(terms);
                  //   console.log('step4', true);
                  // } else if (step == 1) {
                  //   if (document.body.contains(document.querySelector('.c7-checkout__content__buttons .c7-button'))) {
                  //     if (document.querySelector('.c7-checkout__content__buttons .c7-button').innerHTML == 'Complete Club Sign Up') {
                  //       $('.c7-checkout__content__summary').append(terms);
                  //     }
                  //   }

                  //   //  console.log('step4', true);
                  // }
                  //  } //document.body.contains(document.querySelector('#custom-terms'))
                });
                // }
              }, 2000);

              // setTimeout(function () {
              //   validate();
              // }, 4000);

              let targetNode = document.querySelector('.c7-checkout__content');

              // Options for the observer (which mutations to observe)
              let config = { attributes: true, childList: true, subtree: true };

              function addClubPolicy() {
                //  console.log('clubpolicy');

                setTimeout(function () {
                  validate();
                }, 1000);
              }

              // Callback function to execute when mutations are observed
              function mutate(mutations) {
                addClubPolicy();
              }

              addClubPolicy();

              // Create an observer instance linked to the callback function
              let observer = new MutationObserver(mutate);

              // Start observing the target node for configured mutations
              observer.observe(targetNode, config);
            } //club
          }; //add terms to club

          // $(document).on('click', '.c7-checkout__content__buttons .c7-button', function() {
          //   addTermsToClub();
          // }); //on click

          // //this is the club signup modal - clicking on login during club sign up process
          // $(document).on('click', '.c7-account-login--returning-customer .c7-button', function() {
          //   addTermsToClub();
          // }); //on click

          addTermsToClub();

          // //checkbox input itself check
          // $(document).on('click', '#confirm-club-conditions', function() {
          //   validate();
          // }); //on click
        } //clubCheck

        clubCheck();
      }, 2500);
    });
  },
  c7LimitClubCancel: function () {
    let previousUrl = '';
    let timer;
    let amendCancelFlag = false;

    const observer = new MutationObserver(function (mutations) {
      let urlCapture = new URL(window.location);

      if (urlCapture.pathname !== previousUrl) {
        previousUrl = urlCapture.pathname;
        // return urlCapture.pathname;
      }

      function changeCancel() {
        console.log('cancel club');

        if (urlCapture.pathname.includes('profile') && !amendCancelFlag) {
          if (!document.body.contains(document.querySelector('.c7-account-menu'))) return;

          if ($(document).find('.c7-club-actions__cancel').length) {
            $(document).find('.c7-club-actions__cancel').remove();
            $(document)
              .find('.c7-club-actions--hold-cancel')
              .append('<a href="mailto:wineclub@rombauer.com?subject=Club Cancel Request&body=Please cancel the club membership associated with this email.">Cancel club</a>');
          }

          // accountMenu.insertAdjacentHTML('beforeEnd', portalLink);

          amendCancelFlag = !amendCancelFlag;

          setTimeout(() => {
            amendCancelFlag = false;
          }, 4000);
        } else {
          observer.disconnect();
        }
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        changeCancel();
      }, 500);
    });

    const config = { subtree: true, childList: true };
    observer.observe(document, config);
  },
  c7FixBodyCheckout: function () {
    $(window).on('load', function () {
      setTimeout(() => {
        if (!document.body.contains(document.querySelector('#c7-checkout-content'))) {
          if (document.querySelector('body').classList.contains('fixed')) {
            document.querySelector('body').classList.remove('fixed');
          }
        } else {
          document.querySelector('body').classList.add('fixed');
        }
      }, 750);
    });
  },
  ageGate: function () {
    let showAgeGate = Cookies.get('over21');
    let url = new URL(location.href).pathname;
    let self = this; // Store this reference

    // Check if age gate elements exist on the page
    let birthMonthInput = document.getElementById('birthMonth');
    let birthDayInput = document.getElementById('birthDay');
    let birthYearInput = document.getElementById('birthYear');

    // If age gate isn't present on the page, return early
    if (!document.querySelector('#age-gate') || !birthMonthInput || !birthDayInput || !birthYearInput) {
      return;
    }

    birthMonthInput.addEventListener('keyup', function (event) {
      App.checkAge();
      App.handleEnterKey(event);
    });

    birthDayInput.addEventListener('keyup', function (event) {
      App.checkAge();
      App.handleEnterKey(event);
    });

    birthYearInput.addEventListener('keyup', function (event) {
      App.checkAge();
      App.handleEnterKey(event);
      App.fallbackAgeCheck();
    });

    // Add auto-tabbing functionality
    birthMonthInput.addEventListener('input', function () {
      if (this.value.length === 2) {
        birthDayInput.focus();
      }
    });

    birthDayInput.addEventListener('input', function () {
      if (this.value.length === 2) {
        birthYearInput.focus();
      }
    });

    App.addInputValidation(birthMonthInput, 1, 12);
    App.addInputValidation(birthDayInput, 1, 31);
    App.addInputValidation(birthYearInput, 1900, 3000);

    birthYearInput.addEventListener('blur', App.fallbackAgeCheck);

    // Add click event to the existing button
    var existingButton = document.querySelector('.landing-btn.cookies');
    if (existingButton) {
      existingButton.addEventListener('click', App.handleAgeVerificationAction);
    }

    // Setup MutationObserver to watch for dynamically added buttons
    const landingPageWrap = document.querySelector('.landing-page__wrap');
    if (landingPageWrap) {
      const observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type === 'childList') {
            // After any DOM change, check if we need to update buttons
            App.checkAge();
          }
        }
      });

      // Start observing
      observer.observe(landingPageWrap, {
        childList: true,
        subtree: true,
      });
    }

    // Also run checkAge at regular intervals to catch any buttons added via other methods
    var checkInterval = setInterval(function () {
      if (document.querySelector('#age-gate')) {
        App.checkAge();
      } else {
        clearInterval(checkInterval);
      }
    }, 1000);

    if (typeof showAgeGate === 'undefined') {
      if (url == '/privacy-notice/') return false;
      MicroModal.show('age-gate', {
        onShow: function (modal) {
          Util.disableScroll(); // Use stored reference
          self.videoPlayerGate();
        },
        onClose: function (modal) {
          // Make sure scrolling is fully re-enabled
          Util.enableScroll();

          // Force body overflow to be visible in case enableScroll didn't fully work
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';

          Cookies.set('over21', 'true', { expires: 90 });
          setTimeout(function () {
            var ageGate = document.querySelector('#age-gate');
            if (ageGate) {
              ageGate.remove();

              // Double check scrolling is enabled after DOM is updated
              Util.enableScroll();
              document.body.style.overflow = '';
            }
          }, 500);
        },
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
      });
    } else {
      document.querySelector('#age-gate').remove();
    }

    // Do an initial check to handle any buttons that might already be present
    App.checkAge();
  },
  handleEnterKey: function (event) {
    if (event.key === 'Enter') {
      // Make sure inputs exist before validating
      if (!document.getElementById('birthDay') || !document.getElementById('birthMonth') || !document.getElementById('birthYear')) {
        return;
      }

      App.checkAge(); // Validates the input values

      // Check default cookie button first
      var enterButton = document.querySelector('.landing-btn.cookies');
      if (enterButton && !enterButton.classList.contains('disabled')) {
        enterButton.click(); // Triggers the click event on the button if validation passes
        return;
      }

      // Then check for optimizely buttons
      var optimizelyButtons = document.querySelectorAll('.landing-page__wrap .rmbr.btn.btn--with-arrow');
      for (var i = 0; i < optimizelyButtons.length; i++) {
        var button = optimizelyButtons[i];
        if (button && App.isAgeVerified()) {
          button.click();
          break;
        }
      }
    }
  },
  isAgeVerified: function () {
    // Check if age entered is valid and over 21
    var birthDayInput = document.getElementById('birthDay');
    var birthMonthInput = document.getElementById('birthMonth');
    var birthYearInput = document.getElementById('birthYear');

    // Early return if any of the required inputs don't exist on the page
    if (!birthDayInput || !birthMonthInput || !birthYearInput) {
      return false;
    }

    var birthMonthValue = birthMonthInput.value;
    var birthYearValue = birthYearInput.value;

    if (birthDayInput.value && birthMonthValue && birthYearValue && birthYearValue.length === 4) {
      var birthDay = parseInt(birthDayInput.value, 10);
      var birthMonth = parseInt(birthMonthValue, 10);
      var birthYear = parseInt(birthYearValue, 10);

      if (!isNaN(birthDay) && !isNaN(birthMonth) && !isNaN(birthYear)) {
        var validDay = App.validateDay(birthDay, birthMonth, birthYear);
        if (validDay !== false) {
          return App.isOver21(validDay, birthMonth, birthYear);
        }
      }
    }
    return false;
  },
  checkAge: function () {
    let birthDayInput = document.getElementById('birthDay');
    let birthMonthInput = document.getElementById('birthMonth');
    let birthYearInput = document.getElementById('birthYear');

    // Early return if any of the required inputs don't exist on the page
    if (!birthDayInput || !birthMonthInput || !birthYearInput) {
      return;
    }

    let birthMonthValue = birthMonthInput.value;
    let birthYearValue = birthYearInput.value;

    // Handle default cookie button
    var cookieButton = document.querySelector('.landing-btn.cookies');

    // Always get all optimizely buttons
    var optimizelyButtons = document.querySelectorAll('.landing-page__wrap .rmbr.btn.btn--with-arrow');

    // Check for error message
    var errorMsg = document.getElementById('age-verification-error');

    // Process any optimizely buttons - these always remain visibly enabled
    for (var i = 0; i < optimizelyButtons.length; i++) {
      var btn = optimizelyButtons[i];
      if (btn) {
        // Always keep optimizely buttons visibly enabled
        gsap.to(btn, { opacity: 1, duration: 0.35 });

        // Make sure they have click handler
        if (!btn.hasAttribute('data-age-verification-bound')) {
          btn.setAttribute('data-age-verification-bound', 'true');
          btn.addEventListener('click', function (e) {
            e.preventDefault();

            // Create or get error message element
            var errorMsg = document.getElementById('age-verification-error');
            if (!errorMsg) {
              errorMsg = document.createElement('p');
              errorMsg.id = 'age-verification-error';
              errorMsg.style.color = '#f00';
              errorMsg.style.marginBottom = '10px';
              errorMsg.style.textAlign = 'center';
              errorMsg.style.fontSize = '14px';
              errorMsg.innerHTML = 'Enter a valid birthdate';

              // Add error message before age inputs
              var ageInputs = document.querySelector('.age-inputs');
              if (ageInputs) {
                ageInputs.parentNode.insertBefore(errorMsg, ageInputs);
              }
            }

            // Only proceed if age is verified
            if (App.isAgeVerified()) {
              // Hide error message if exists
              if (errorMsg) {
                errorMsg.style.display = 'none';
              }

              // GSAP scaling effect for the button
              gsap.to(e.currentTarget, { scale: 1, duration: 1 });

              // Set cookie and remove age gate
              Cookies.set('over21', 'true', { expires: 90 });
              setTimeout(function () {
                var ageGate = document.querySelector('#age-gate');
                if (ageGate) {
                  ageGate.remove();

                  // Ensure scrolling is re-enabled
                  Util.enableScroll();
                  document.body.style.overflow = '';
                  document.body.style.position = '';
                  document.body.style.top = '';
                  document.body.style.width = '';
                }
              }, 500);
            } else {
              // Show error message and highlight input fields
              if (errorMsg) {
                errorMsg.style.display = 'block';

                // Add animation to the error message
                gsap.fromTo(errorMsg, { opacity: 0, y: -5 }, { opacity: 1, y: 0, duration: 0.3 });

                // Highlight any empty or invalid inputs
                var monthInput = document.getElementById('birthMonth');
                var dayInput = document.getElementById('birthDay');
                var yearInput = document.getElementById('birthYear');

                // Subtle shake animation for empty fields
                var emptyFields = [];
                if (!monthInput.value) emptyFields.push(monthInput);
                if (!dayInput.value) emptyFields.push(dayInput);
                if (!yearInput.value) emptyFields.push(yearInput);

                if (emptyFields.length > 0) {
                  gsap.to(emptyFields, {
                    x: [-5, 5, -5, 5, 0],
                    duration: 0.5,
                  });
                }

                // Focus on the first empty field or the month field if all filled but invalid
                if (emptyFields.length > 0) {
                  emptyFields[0].focus();
                } else {
                  monthInput.focus();
                }
              }
            }
          });
        }
      }
    }

    // Check if all fields are filled and are valid numbers
    if (!cookieButton) {
      return; // No default button to update
    }

    if (birthDayInput.value && birthMonthValue && birthYearValue) {
      let birthDay = parseInt(birthDayInput.value, 10);
      let birthMonth = parseInt(birthMonthValue, 10);
      let birthYear = parseInt(birthYearValue, 10);

      // Additional check to ensure birth year is a four-digit number
      if (!isNaN(birthDay) && !isNaN(birthMonth) && !isNaN(birthYear) && birthYearValue.length === 4) {
        // Validate the day and check if it's a valid date
        let validDay = App.validateDay(birthDay, birthMonth, birthYear);
        if (validDay !== false) {
          if (App.isOver21(validDay, birthMonth, birthYear)) {
            // Enable the enter button and update its opacity
            gsap.to(cookieButton, { opacity: 1, duration: 0.35 });
            cookieButton.classList.remove('disabled');

            // Hide error message if it exists
            if (errorMsg) {
              errorMsg.style.display = 'none';
            }
          } else {
            // Disable the enter button and update its opacity
            gsap.to(cookieButton, { opacity: 0, duration: 0.35 });
            cookieButton.classList.add('disabled');
          }
        } else {
          // Clear the day input and disable the enter button
          birthDayInput.value = '';
          gsap.to(cookieButton, { opacity: 0, duration: 0.35 });
          cookieButton.classList.add('disabled');
        }
      } else {
        // If any of the fields are not valid numbers or year is not a four-digit number, disable the enter button
        gsap.to(cookieButton, { opacity: 0, duration: 0.35 });
        cookieButton.classList.add('disabled');
      }
    } else {
      // If any of the fields are empty, disable the enter button
      gsap.to(cookieButton, { opacity: 0, duration: 0.35 });
      cookieButton.classList.add('disabled');
    }
  },
  handleAgeVerificationAction: function (e) {
    e.preventDefault();

    var birthDay = parseInt(document.getElementById('birthDay').value);
    var birthMonth = parseInt(document.getElementById('birthMonth').value);
    var birthYear = parseInt(document.getElementById('birthYear').value);

    if (!isNaN(birthDay) && !isNaN(birthMonth) && !isNaN(birthYear)) {
      birthDay = App.validateDay(birthDay, birthMonth, birthYear);

      if (App.isOver21(birthDay, birthMonth, birthYear)) {
        // GSAP scaling effect for the button
        gsap.to(e.currentTarget, { scale: 1, duration: 1 });

        // Set cookie and remove age gate
        Cookies.set('over21', 'true', { expires: 90 });
        setTimeout(function () {
          var ageGate = document.querySelector('#age-gate');
          if (ageGate) {
            ageGate.remove();

            // Ensure scrolling is re-enabled
            Util.enableScroll();
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
          }
        }, 500);
      } else {
        // Handle under-age case
      }
    } else {
      // Handle invalid input case
    }
  },
  isOver21: function (birthDay, birthMonth, birthYear) {
    const today = new Date();
    const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age >= 21;
  },
  validateDay: function (day, month, year) {
    const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Check if the day is within the valid range for the given month
    if (day >= 1 && day <= daysInMonth[month - 1]) {
      return day;
    } else {
      return false; // Indicate invalid day
    }
  },
  addInputValidation: function (input, min, max) {
    input.addEventListener('change', function () {
      let value = parseInt(input.value, 10);
      if (input.id === 'birthYear') {
        let currentYear = new Date().getFullYear();
        if (value > currentYear || value < min) {
          input.value = ''; // Clear the input if the year is out of range
        }
      } else {
        if (value < min) {
          input.value = min;
        } else if (value > max) {
          input.value = max;
        }
      }
    });
  },
  fallbackAgeCheck: function () {
    // Check if age gate elements exist before continuing
    if (!document.getElementById('birthDay') || !document.getElementById('birthMonth') || !document.getElementById('birthYear')) {
      return;
    }

    setTimeout(function () {
      App.checkAge(); // This will now handle all buttons regardless of when they were added
    }, 500); // Adjust the timeout as needed
  },
  c7NVFlightIndoor: function () {
    let url = new URL(window.location);

    if (!document.body.contains(document.querySelector('.reserve__area'))) return false;

    //Napa Valley Indoor: Max party size = 5
    if (url.pathname === '/reservations/napa-valley-tasting-flight-indoor/') {
      let targetNodeNVIndoor = document.querySelector('.reserve__area');

      // Options for the observer (which mutations to observe)
      let configNV = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      function mutate(mutations) {
        App.c7RemoveOptions('c7-guestCount', 'NV');
      }

      // removeOptions('c7-guestCount');
      // Create an observer instance linked to the callback function
      let observerSV = new MutationObserver(mutate);

      // Start observing the target node for configured mutations
      observerSV.observe(targetNodeNVIndoor, configNV);
    } //napa-valley-tasting-flight-indoor
  },
  c7SFFlightIndoor: function () {
    let url = new URL(window.location);

    if (!document.body.contains(document.querySelector('.reserve__area'))) return false;

    if (url.pathname === '/reservations/sierra-foothills-indoor-tasting-flight/') {
      var targetNodeNVIndoor = document.querySelector('.reserve__area');

      // Options for the observer (which mutations to observe)
      var configNV = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      function mutate(mutations) {
        App.c7RemoveOptions('c7-guestCount', 'SF');
      }

      // removeOptions('c7-guestCount');
      // Create an observer instance linked to the callback function
      var observerSV = new MutationObserver(mutate);

      // Start observing the target node for configured mutations
      observerSV.observe(targetNodeNVIndoor, configNV);
    } //napa-valley-tasting-flight-indoor
  },
  c7RemoveOptions: function (elID, type) {
    let selectobject = document.getElementById(elID);
    let number = type == 'NV' ? 5 : 6;
    if (selectobject) {
      for (let i = 0; i < selectobject.length; i++) {
        if (selectobject.options[i].value > number) {
          selectobject.remove(i);
        }
      }
    }
  },
  c7removeOptionsCollection: function () {
    jQuery(window).on('load', function () {
      //indoor tasting flights
      App.c7NVFlightIndoor();
      App.c7SFFlightIndoor();
    }); //load
  },
  c7ResoRemoveZeros: function () {
    let urlLoad = new URL(window.location);

    window.myRequestLog = []; // Using `var` (instead of `let` or `const`) so it creates an implicit property on the (global) `window` object so you can easily access this log from anywhere just by using `window.myRequestLog[...]`.
    function onRequestsObserved(batch) {
      window.myRequestLog.push(...batch.getEntries());
      window.myRequestLog.forEach(function (value) {
        if (value.initiatorType == 'xmlhttprequest') {
          let valueURL = new URL(value.name);
          let url = new URL(window.location);

          if (valueURL.pathname.includes('process') && url.pathname.includes('/reservation/checkout/receipt')) {
            jQuery('.c7-cart-summary__total').remove();
            jQuery('.c7-cart-summary div div:nth-of-type(2)').remove();
          }
        }
      });
    }
    window.requestObserver = new PerformanceObserver(onRequestsObserved);
    window.requestObserver.observe({ type: 'resource' /*, buffered: true */ });

    //hard load
    jQuery(window).on('load', () => {
      setTimeout(function () {
        if (urlLoad.pathname.includes('/reservation/checkout/receipt')) {
          jQuery('.c7-cart-summary__total').remove();
          jQuery('.c7-cart-summary div div:nth-of-type(2)').remove();
        }
      }, 3500);
    });
  },
  c7LoginCheck: function () {
    let C7tenant = window.stagingC7 ? 'staging-rombauer' : 'rombauer-vineyards';

    let customerToken = Cookies.get('customerToken');

    if (typeof customerToken == 'undefined') {
      localStorage.setItem('loginStatus', null);
      window.c7User = null;
      return;
    }
    //console.log('customerToken', Cookies.get('customerToken'));

    fetch(`https://api.commerce7.com/v1/customer/self`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: C7tenant,
        authorization: customerToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.id !== null) {
          window.c7User = data;
          localStorage.setItem('loginStatus', 'loggedIn');
        }
      });

    //  $(window).on('load', function() {
    setTimeout(() => {
      let targetNode = document.getElementById('c7-account');

      // Options for the observer (which mutations to observe)
      let config = { attributes: true, childList: true, subtree: true };

      function accountLoginUpdate() {
        let logInEl = document.querySelector('#c7-login .c7-login__logged-in');
        let accountIcon = document.querySelector('.menu-btn--profile img');
        let accountName = document.querySelector('.hover-account-ctr .name');
        let hoverAcctCtr = document.querySelector('.hover-account-ctr');
        let mobAccountLink = document.querySelector('.my__account__mobile');

        if (localStorage.getItem('loginStatus') !== null) {
          let name = window.c7User.firstName;
          accountIcon.src = '/wp-content/themes/affinity-custom-webpack/assets/svg/loggedin_icon.svg';
          accountName.innerText = `Hello ${name}!`;
          document.querySelector('.menu-btn.menu-btn--profile').href = '/profile/account';

          mobAccountLink.innerHTML = `<a href='/profile/login'>${name}! (<span class="mobile-account-link">My Account</span>)</a>`;

          //localStorage.setItem('loginStatus', 'loggedIn');
        }
      }

      // Callback function to execute when mutations are observed
      function mutate(mutations) {
        accountLoginUpdate();
      }

      accountLoginUpdate();

      // Create an observer instance linked to the callback function
      let observer = new MutationObserver(mutate);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }, 1000);
    // });
  },
  c7LoginIcon: function () {
    let accountIconCtr = document.querySelector('.profile-icon-ctr');
    let profileLink = document.querySelector('.logout-link-ctr .logout-link');
    let hoverAcctCtr = document.querySelector('.hover-account-ctr');
    let rightSection = document.querySelector('.header__right-sec');

    function fadeUp() {
      // let logInEl = document.querySelector('#c7-login .c7-login__logged-in');
      if (window.c7User === null || window.c7User === undefined) return false;

      if (hoverAcctCtr.style.opacity < 0.5) {
        gsap.to(hoverAcctCtr, {
          duration: 0.25,
          yPercent: -107,
          xPercent: 0,
          opacity: 1,
          ease: 'Power3.inOut',
          onComplete: function () {
            gsap.set(hoverAcctCtr, { zIndex: 999 });
          },
        });
      }
    }

    function fadeDown(e) {
      gsap.to(hoverAcctCtr, { duration: 0.25, zIndex: -1, yPercent: 0, xPercent: 0, opacity: 0, ease: 'Power3.inOut' });
    }

    accountIconCtr.addEventListener('mouseover', fadeUp);
    hoverAcctCtr.addEventListener('mouseover', fadeUp);
    rightSection.addEventListener('mouseleave', fadeDown);

    profileLink.addEventListener('click', () => {
      window.location = '/profile/logout';
    });
  },
  shopSetSelectToOne: function () {
    let collectionNode = document.querySelector('.c7-product-collection');

    // Options for the observer (which mutations to observe)
    let config = { attributes: true, childList: true, subtree: true };

    function updateC7Selects() {
      if (!document.body.contains(collectionNode)) return false;

      let c7Select = document.querySelectorAll('.c7-product__variant__add-to-cart__select');

      [...c7Select].forEach((element) => {
        // for (let opt, j = 0; (opt = element.options[j]); j++) {
        //   //If the option of value is equal to the option we want to select.
        //   console.log('element.options', element.options[j]);
        //   if (element.options[j].value == 1) {
        //     //Select the option and break out of the for loop.
        //     element.selectedIndex = j;
        //     element.value = 1;
        //     console.log('element.selectedIndex', element.selectedIndex);
        //     element.dispatchEvent(new Event('change'));
        //     return false;
        //   }
        // }
        element.parentElement.style.display = 'block';
      });
    }

    // Callback function to execute when mutations are observed
    function mutate(mutations) {
      updateC7Selects();
    }

    // Create an observer instance linked to the callback function
    let observer = new MutationObserver(mutate);

    // Start observing the target node for configured mutations
    if (document.body.contains(collectionNode)) {
      observer.observe(collectionNode, config);
    }
  },
  PDPSoldOut: function () {
    let productPageNode = document.querySelector('.product__area__mine');

    // Options for the observer (which mutations to observe)
    let config = { attributes: true, childList: true, subtree: true };

    function soldOut() {
      if (!document.body.contains(productPageNode) || !document.body.contains(document.querySelector('.pruduct-details-sec__cart-sec'))) return false;

      if (document.querySelector('.pruduct-details-sec__cart-sec').firstElementChild == null) {
        //if addtocart is empty
        let subtitle = document.querySelector('.notvisible.subtitle-field').innerText;
        document.querySelector('.pruduct-details-sec__cart-sec').innerHTML = `<h4>${subtitle}</h4>`;
      }
    }

    // Callback function to execute when mutations are observed
    function mutate(mutations) {
      soldOut();
    }

    // Create an observer instance linked to the callback function
    let observer = new MutationObserver(mutate);

    // Start observing the target node for configured mutations
    if (document.body.contains(productPageNode)) {
      observer.observe(productPageNode, config);
    }
  },
  homeTextSplits: function () {
    window.addEventListener('load', function () {
      if (!document.body.contains(document.querySelector('.promotion-outer-ctr .js-original'))) return false;
      if (!document.body.contains(document.querySelector('.js-masked-el-club'))) return false;

      let transform = document.querySelector('.promotion-outer-ctr .js-original').style.transform;
      let re = /translate3d\((?<x>.*?)px, (?<y>.*?)px, (?<z>.*?)px/;
      let results = re.exec(transform);
      let orignalHeight = document.querySelector('.promotion-outer-ctr .js-original').offsetHeight;

      //console.log(results.groups.x, results.groups.y, results.groups.z);

      let originalTitle = document.querySelector('.promotion-outer-ctr .js-original').getBoundingClientRect(),
        maskedEl = document.querySelector('.promotion-outer-ctr .js-masked-el').getBoundingClientRect(),
        offset = originalTitle.top - maskedEl.top;

      // console.log('offset', offset);
      // console.log('Transform X before', gsap.getProperty(originalTitle, 'y'));
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.promotion-outer-ctr .js-original',
          endTrigger: '.promotion-outer-ctr .js-original',
          //markers: true,
          scrub: true,
          onUpdate: (self) => {
            transform = document.querySelector('.promotion-outer-ctr .js-original').style.transform;
            results = re.exec(transform);

            try {
              gsap.set('.promotion-outer-ctr .js-masked-el', { y: -(orignalHeight - results.groups.y) });
            } catch (e) {
              // statements to handle any exceptions
            }
          },
        },
      });

      // tl.fromTo('.promotion-outer-ctr .js-masked-el', { y: offset - results.groups.y }, { y: offset + results.groups.y });

      //Wine Club Section

      let club = document.querySelector('.club-heading');
      let clubMasked = document.querySelector('.js-masked-el-club');
      let clubX = club.getBoundingClientRect().x;
      let clubMaskedX = clubMasked.getBoundingClientRect().x;
      let clubY = club.getBoundingClientRect().y;
      let clubMaskedY = clubMasked.getBoundingClientRect().y;

      gsap.set(clubMasked, { x: clubX - clubMaskedX, y: clubY - clubMaskedY, force3D: true });

      let clubMaskCtr;
      let clubMaskCtrResults;
      let clubMaskEl;
      let clubMaskElResults;

      let wineImageTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wine-club-section .img-vdo-cpy__col2',
          endTrigger: '.wine-club-section .img-vdo-cpy__col2',
          start: 'center bottom',
          // markers: true,
          scrub: true,
          onUpdate: (self) => {
            clubX = club.getBoundingClientRect().x;
            clubMaskedX = clubMasked.getBoundingClientRect().x;
            clubY = club.getBoundingClientRect().y;
            clubMaskedY = clubMasked.getBoundingClientRect().y;

            clubMaskCtr = document.querySelector('.wine-club-section .img-vdo-cpy__col2 .mask').style.transform;
            clubMaskEl = document.querySelector('.wine-club-section .img-vdo-cpy__col2 .js-masked-el-club').style.transform;

            clubMaskCtrResults = re.exec(clubMaskCtr);
            clubMaskElResults = re.exec(clubMaskEl);

            if (clubMaskCtrResults != null && clubMaskElResults != null) {
              let math = parseInt(-Math.abs(clubMaskElResults.groups.y, 10)) + parseInt(Math.abs(clubMaskCtrResults.groups.y), 10);
              let orgDifferenceY = clubY - clubMaskedY;

              gsap.set(clubMasked, { y: orgDifferenceY + math + -Math.abs(clubMaskCtrResults.groups.y) });

              // console.log('clubMaskElResults', clubMaskElResults.groups.y);
              // console.log('clubMaskCtrResults', Math.abs(clubMaskCtrResults.groups.y));
              // console.log('math', math);
            }
          },
        },
      });
      wineImageTL.to(['.wine-club-section .img-vdo-cpy__col2 img', '.wine-club-section .img-vdo-cpy__col2 .mask'], { y: -50 });
      ///
    });
  },
  homeCanvas: function () {
    let canvasCtr = document.querySelector('.experience-canvas-ctr');
    const loader = PIXI.Loader.shared;
    let dome;
    let domeWidth;
    let domeHeight;
    let maskImage;
    let maskWidth;
    let maskHeight;
    let text;
    let style1;
    let style2;
    let text2;

    if (!document.body.contains(canvasCtr)) return false;

    function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
      let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

      return { width: srcWidth * ratio, height: srcHeight * ratio };
    }

    function init() {
      // Get the p
      const parent = app.view.parentNode;

      //console.log('app', app);

      // You can use the 'screen' property as the renderer visible
      // area, this is more useful than view.width/height because
      // it handles resolution
      //  container.position.set(app.screen.width / 2, app.screen.height / 2);

      // console.log('app.screen.width', app.screen.width);
      // console.log('app.screen.height', app.screen.height);

      // console.log('canvasCtr.offsetWidth', canvasCtr.offsetWidth);
      // console.log('canvasCtr.offsetHeight', canvasCtr.offsetHeight);
      // // console.log('calculateAspectRatioFit', calculateAspectRatioFit(domeWidth, domeHeight, canvasCtr.offsetWidth, canvasCtr.offsetHeight));
      // console.log('CARF-width', calculateAspectRatioFit(domeWidth, domeHeight, canvasCtr.offsetWidth, canvasCtr.offsetHeight).width);
      // console.log('CARF-height', calculateAspectRatioFit(domeWidth, domeHeight, canvasCtr.offsetWidth, canvasCtr.offsetHeight).height);

      let carfHeight = calculateAspectRatioFit(domeWidth, domeHeight, canvasCtr.offsetWidth, canvasCtr.offsetHeight).height;
      let carfWidth = calculateAspectRatioFit(domeWidth, domeHeight, canvasCtr.offsetWidth, canvasCtr.offsetHeight).width;

      //console.log('container', container);

      // maskImage.width = carfWidth * 0.75;
      // maskImage.height = carfHeight * 0.75;

      // style1.fontSize = carfWidth * 0.2;
      // style2.fontSize = carfWidth * 0.2;

      ScrollTrigger.matchMedia({
        // large
        '(min-width: 960px)': function () {
          // setup animations and ScrollTriggers for screens 960px wide or greater...
          // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
          // Resize the renderer
          app.renderer.resize(carfWidth * 1.5, `${window.expObj.imageHeight}` * 0.5);

          ScrollTrigger.refresh();
        },

        // medium
        '(min-width: 600px) and (max-width: 959px)': function () {
          // The ScrollTriggers created inside these functions are segregated and get
          // reverted/killed when the media query doesn't match anymore.
        },

        // small
        '(max-width: 599px)': function () {
          // The ScrollTriggers created inside these functions are segregated and get
          // reverted/killed when the media query doesn't match anymore.
          // Resize the renderer
          app.renderer.resize(carfWidth * 1.5, `${window.expObj.imageHeight}` * 0.25);

          ScrollTrigger.refresh();
        },

        // all
        all: function () {
          // ScrollTriggers created here aren't associated with a particular media query,
          // so they persist.
        },
      });

      container.width = carfWidth * 1.1;
      container.height = carfHeight;

      container.x = app.screen.width / 2;
      container.y = app.screen.height / 2;

      window.addEventListener(
        'load',
        function () {
          setTimeout(() => {
            let expTL = gsap.timeline({
              scrollTrigger: {
                trigger: '.experiance-sec .js-start',
                endTrigger: '.experiance-sec__content-wrap p',
                start: 'center 75%',
                end: 'center center',
                // markers: true,
                scrub: 0.95,
              },
            });
            expTL.to([text, text2], { y: -25, ease: 'Power3.inOut' });
          });

          ScrollTrigger.refresh();
        },
        1000
      );
    }

    let app = new PIXI.Application({
      width: window.innerWidth,
      height: `${window.expObj.imageHeight}`,
      backgroundAlpha: 0,
      antialias: true,
      resolution: 1,
    });

    //console.log('app.renderer.view', app.renderer.view.width);

    // app.renderer.resize(window.innerWidth, window.innerHeight);

    let container = new PIXI.Container();
    container.x = app.screen.width / 2;
    container.y = app.screen.height / 2;
    app.stage.addChild(container);

    loader.add('dome', `${window.expObj.image}`);
    loader.onComplete.add(function (loader, resources) {
      //console.log('resources', resources);
      dome = new PIXI.Sprite(loader.resources.dome.texture);
      domeWidth = dome.width;
      domeHeight = dome.height;
      dome.anchor.set(0.5);
      //console.log('domeWidth', domeWidth);
      //console.log('domeHeight', domeHeight);

      container.addChild(dome);
    });

    loader.add('maskImage', `${window.expObj.maskImage}`);
    loader.onComplete.add(function (loader, resources) {
      //console.log('resources', resources);
      maskImage = new PIXI.Sprite(loader.resources.maskImage.texture);
      maskWidth = maskImage.width;
      maskHeight = maskImage.height;
      maskImage.anchor.set(0.5);

      container.addChild(maskImage);
    });

    function startup() {
      style1 = new PIXI.TextStyle({
        fontFamily: 'ivymode',
        fill: 0x6a7893,
        align: 'center',
        fontSize: 280,
        fontWeight: 200,
      });
      style2 = new PIXI.TextStyle({
        fontFamily: 'ivymode',
        fill: 0xffffff,
        align: 'center',
        fontSize: 280,
        fontWeight: 200,
      });

      text = new PIXI.Text(`${window.expObj.heading}`, style1);
      text.anchor.set(0.5);
      text.position.set(0, -700);

      text2 = new PIXI.Text(`${window.expObj.heading}`, style2);
      text2.anchor.set(0.5);
      text2.position.set(0, -700);

      // let dome = new PIXI.Sprite.from(`${window.expObj.image}`);
      //let maskSource = new PIXI.Sprite.from(`${window.expObj.maskImage}`);
      // dome.height = canvasCtr.offsetHeight;
      // maskSource.height = canvasCtr.offsetHeight;
      // console.log('dome.height', dome.height);
      // console.log('dome.width', dome.width);

      text2.mask = maskImage;
      container.addChild(text);
      /// container.addChild(dome);
      //  container.addChild(maskSource);
      container.addChild(text2);

      // container.pivot.x = container.width / 2;
      // container.pivot.y = container.height / 2;

      let flag = false;

      // Listen for animate update
      app.ticker.add(function (delta) {
        // your code
        if (canvasCtr.offsetWidth != 0 && flag == false) {
          flag = true;
          // app.screen.width = canvasCtr.offsetWidth;
          // app.screen.height = canvasCtr.offsetHeight;
          init();
        }
      });
    }

    canvasCtr.appendChild(app.view);

    // Resize function window
    let resize = function () {
      init();
    };

    loader.load(startup).onComplete.add(() => {
      resize();
      window.addEventListener('resize', resize());
    });
  },
  allocation: function () {
    $(window).on('load', function () {
      setTimeout(function () {
        var targetNode = document.querySelector('#c7-content');
        let flag = false;

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true, subtree: true };

        function changeCopy() {
          // if (!document.body.contains(document.querySelector('.page-template-product-details'))) return false;
          // if (!document.body.contains(document.querySelector('.c7-product__login-message p'))) return false;
          if (!flag) {
            let message = document.querySelectorAll('.c7-product__login-message p');
            [...message].forEach((e) => {
              e.innerHTML = '<p>Please login to purchase.</p>';
            });

            flag = !flag;

            observer.disconnect();
          }
        }

        // Callback function to execute when mutations are observed
        function mutate(mutations) {
          changeCopy();
        }

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(mutate);

        // Start observing the target node for configured mutations
        if (targetNode != null) {
          observer.observe(targetNode, config);
        }

        if (document.body.contains(document.querySelector('.c7-product__login-message p'))) {
          let message = document.querySelectorAll('.c7-product__login-message p');
          [...message].forEach((e) => {
            e.innerHTML = '<p>Please login to purchase.</p>';
          });

          observer.disconnect();
        }
      }, 1500);
    });
  },
  shippingChoice: function () {
    $(window).on('load', function () {
      setTimeout(function () {
        let url = new URL(window.location);

        if (url.pathname.includes('/checkout/')) {
          App.shippingSelect();

          let targetNode = document.querySelector('.c7-checkout__content');

          // Options for the observer (which mutations to observe)
          let config = { attributes: true, childList: true, subtree: true };

          // Create an observer instance linked to the callback function
          let observer = new MutationObserver(mutate);

          // Start observing the target node for configured mutations
          if (targetNode) {
            observer.observe(targetNode, config);
          }

          // Callback function to execute when mutations are observed
          function mutate(mutations) {
            App.shippingSelect();
          }

          //don't contradict C7 shipping choice on checkout if dropped off there
          if (document.body.contains(document.querySelector('.c7-checkout__content__summary'))) {
            localStorage.setItem('shippingChoice', document.querySelector('.shipping-method-row').innerText.split('\n')[0]);
          }

          App.shippingSelect();
        }
      }, 3000);
    });
  },
  shippingSelect: function () {
    if (!document.body.contains(document.querySelector('.c7-checkout__content__radio-options-group'))) return false;

    $('.c7-checkout__content__radio-options-group input[name="shippingServiceId"]').on('click', () => {
      App.grabShipping();

      let data = localStorage.getItem('shippingChoice');
      //get the last price in array in case of discounts
      let dataPrice = localStorage.getItem('shippingPrice').split('$').slice(-1).toString();
      let shippingCopy = document.querySelector('.c7-cart-summary__subtotal + div > div').innerText;
      let shippingCopySplit = shippingCopy.split('to');

      document.querySelector('.c7-cart-summary__subtotal + div > div').innerText = data + ' to' + shippingCopySplit[1];
      document.querySelector('.c7-cart-summary__subtotal + div > .c7-cart-items__price').innerText = `$${dataPrice}`;

      // let targetNode = document.querySelector('#c7-checkout-content');
      // let shippingCopy = targetNode.querySelector('.c7-cart-summary__subtotal + div > div').innerText;

      // if (data != null) {
      //   console.log('shippingCopy', shippingCopy);

      //   let c7Checkout = document.querySelector('.c7-checkout-summary');
      //   c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = shippingCopy.replace('Shipping', data);
      // } else {
      //   let c7Checkout = document.querySelector('.c7-checkout-summary');
      //   c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = `Ground ${shippingCopy}`;
      // }
    });

    App.grabShipping();
  },
  grabShipping: function () {
    let shippingChoiceGroup = document.querySelectorAll('.c7-checkout__content__radio-options-group input[name="shippingServiceId"]');

    [...shippingChoiceGroup].forEach((e) => {
      if (e.checked) {
        let id = e.id;
        let shippingChoice = id.replace('c7-', '');

        let label = e.closest('label');
        let shippingPrice = label.querySelector('.c7-radio__right').innerText;

        localStorage.setItem('shippingChoice', shippingChoice);
        localStorage.setItem('shippingPrice', shippingPrice);
      }
    });
  },
  updateShippingMethod: function () {
    $(window).on('load', function () {
      setTimeout(function () {
        let targetNode = document.querySelector('#c7-cart');
        let flag = true;

        // Options for the observer (which mutations to observe)
        let config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        function mutate(mutations) {
          // console.log('mutations', mutations[2].target.offsetParent.children[5].children[1].children[0].innerHTML);
          if (targetNode.contains(targetNode.querySelector('.c7-cart-summary__subtotal + div > div'))) {
            // if (!flag) return false;

            const Style = {
              base: ['color: #fff', 'background-color: #444', 'padding: 2px 4px', 'border-radius: 2px'],
              warning: ['color: #eee', 'background-color: red'],
              success: ['background-color: green'],
            };

            const log = (text, extra = []) => {
              let style = Style.base.join(';') + ';';
              style += extra.join(';'); // Add any additional styles
              console.log(`%c${text}`, style);
            };

            let shippingDiv = targetNode.querySelector('.c7-cart-summary__subtotal + div > div');
            let shippingCopy = '' || mutations[2].target.offsetParent.children[5].children[1].children[0].innerHTML;
            let url = new URL(window.location);
            let data = localStorage.getItem('shippingChoice');

            log(`shippingCopy: ${shippingCopy}`);

            //need the shippingCopy to continue
            if (shippingCopy == '') return false;

            if (data != null) {
              log('data = null');

              targetNode.querySelector('.c7-cart-summary__subtotal + div > div').innerText = shippingCopy.replace('Shipping', data);

              if (url.pathname.includes('/cart/')) {
                let c7Content = document.querySelector('#c7-content');
                c7Content.querySelector('.c7-cart-summary__subtotal + div > div').innerText = shippingCopy.replace('Shipping', data);
              }

              if (url.pathname.includes('/checkout/')) {
                let c7Checkout = document.querySelector('.c7-checkout-summary');

                c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = shippingCopy.replace('Shipping', data);
              }
            } else {
              log('data exists');

              if (localStorage.getItem('loginStatus') == null) {
                targetNode.querySelector('.c7-cart-summary__subtotal + div > div').innerText = ` ${shippingCopy}`;
              } else {
                log('loginStatus else');
                log(`shippingCopy ${shippingCopy}`, Style.success);
                targetNode.querySelector('.c7-cart-summary__subtotal + div > div').innerText = ` ${shippingCopy}`;
              }

              if (url.pathname.includes('/cart/')) {
                let c7Content = document.querySelector('#c7-content');

                if (localStorage.getItem('loginStatus') == null) {
                  c7Content.querySelector('.c7-cart-summary__subtotal + div > div').innerText = ` ${shippingCopy}`;
                } else {
                  c7Content.querySelector('.c7-cart-summary__subtotal + div > div').innerText = `${shippingCopy}`;
                }
              }

              if (url.pathname.includes('/checkout/')) {
                let c7Checkout = document.querySelector('.c7-checkout-summary');
                c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = ` ${shippingCopy}`;
              }
            }

            observer.disconnect();
          }
        } //mutate

        // Create an observer instance linked to the callback function
        let observer = new MutationObserver(mutate);

        // Start observing the target node for configured mutations

        observer.observe(targetNode, config);
      }, 2500);
    });
  },
  updateShippingMethodCheckout: function () {
    $(window).on('load', function () {
      setTimeout(function () {
        let url = new URL(window.location);

        if (url.pathname.includes('/checkout/')) {
          let targetNode = document.querySelector('#c7-checkout-content');
          // let flag = true;

          // Options for the observer (which mutations to observe)
          let config = { attributes: true, childList: true, subtree: true };

          // Callback function to execute when mutations are observed
          function mutate(mutations) {
            if (targetNode.contains(targetNode.querySelector('.c7-cart-summary__subtotal + div > div'))) {
              //  if (!flag) return false;

              let shippingDiv = targetNode.querySelector('.c7-cart-summary__subtotal + div > div');
              let shippingCopy = targetNode.querySelector('.c7-cart-summary__subtotal + div > div').innerText;

              let data = localStorage.getItem('shippingChoice');

              //need the shippingCopy to continue
              if (shippingCopy == '') return false;

              if (data != null) {
                let c7Checkout = document.querySelector('.c7-checkout-summary');
                c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = shippingCopy.replace('Shipping', data);
              } else {
                let c7Checkout = document.querySelector('.c7-checkout-summary');
                c7Checkout.querySelector('.c7-cart-summary__subtotal + div > div').innerText = ` ${shippingCopy}`;
              }

              // flag = !flag;

              observer.disconnect();
            }
          } //mutate

          // Create an observer instance linked to the callback function
          let observer = new MutationObserver(mutate);
          mutate();

          // Start observing the target node for configured mutations

          observer.observe(targetNode, config);

          //continue to shipping method button upon initial login
          $('.c7-checkout__content__buttons .c7-button').on('click', () => {
            setTimeout(function () {
              App.shippingSelect();
            }, 2000);
          });
        }
      }, 2500);
    });
  },
  debounce: function (func, timeout = 1000) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  },
  ada: function () {
    $(window).on('load', function () {
      setTimeout(function () {
        //home

        if (document.body.contains(document.querySelector('.page-template-home'))) {
          console.log('page-template home');
          let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
          let quantityLabelEl = `<p class="ada-label">Quantity</p>`;
          [...addToCart].forEach((e) => {
            e.querySelector('label').ariaLabel = 'quantity';
            e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
          });

          let slideItem = document.querySelectorAll('.js-feedSlider .feed-item');

          [...slideItem].forEach((e) => {
            e.removeAttribute('aria-describedby');
          });

          // let slideItemProductCard = document.querySelectorAll('.product-card');

          // [...slideItemProductCard].forEach((e) => {
          //   e.removeAttribute('aria-describedby');
          // });
        }

        if (document.body.contains(document.querySelector('.page-template-shop-with-filer'))) {
          // Select the node that will be observed for mutations
          const targetNode = document.querySelector('.c7-product-collection');

          // Options for the observer (which mutations to observe)
          const config = { childList: true };

          // Callback function to execute when mutations are observed
          const callback = App.debounce(function (mutationsList, observer) {
            let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
            let quantityLabelEl = `<span class="ada-label">Quantity</span>`;
            [...addToCart].forEach((e) => {
              e.querySelector('label').ariaLabel = 'quantity';
              e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
            });

            observer.disconnect();
          });

          // Create an observer instance linked to the callback function
          const observer = new MutationObserver(callback);

          // Start observing the target node for configured mutations
          observer.observe(targetNode, config);
        }

        if (document.body.contains(document.querySelector('.page-template-collection'))) {
          // Select the node that will be observed for mutations
          const targetNode = document.querySelector('.collection-c7-content');

          // Options for the observer (which mutations to observe)
          const config = { childList: true };

          // Callback function to execute when mutations are observed
          const callback = App.debounce(function (mutationsList, observer) {
            let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
            let quantityLabelEl = `<span class="ada-label">Quantity</span>`;
            [...addToCart].forEach((e) => {
              e.querySelector('label').ariaLabel = 'quantity';
              e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
            });

            observer.disconnect();
          });

          // Create an observer instance linked to the callback function
          const observer = new MutationObserver(callback);

          // Start observing the target node for configured mutations
          observer.observe(targetNode, config);
        }

        if (document.body.contains(document.querySelector('img[src="https://tags.w55c.net/rs?id=7ba69b11004f496b8b3bcdd6b6d20430&t=marketing"]'))) {
          let spacerImg = document.querySelector('img[src="https://tags.w55c.net/rs?id=7ba69b11004f496b8b3bcdd6b6d20430&t=marketing"]');
          spacerImg.alt = '';
        }

        if (document.body.contains(document.querySelector('.page-template-experiences'))) {
          let slideItem = document.querySelectorAll('.js-tastingSlider .slider-item');

          let slideItem2 = document.querySelectorAll('.js-event-sliderExperience .slide-item');

          // [...slideItem].forEach((e) => {
          //   e.removeAttribute('aria-describedby');
          // });

          console.log('experiences');

          [...slideItem].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('img').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });

          [...slideItem2].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('.event-card').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });
        } //experiences

        if (document.body.contains(document.querySelector('.page-template-wine-clubs'))) {
          console.log('wine-clubs');
          let slideItem = document.querySelectorAll('.js-event-sliderExperience .slide-item');

          [...slideItem].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('.event-card').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });

          let slideItem2 = document.querySelectorAll('.js-tabSliderNav .slick-slide');

          [...slideItem2].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('h4').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });

          let slideItem3 = document.querySelectorAll('.js-tabSliderPane .slick-slide');

          [...slideItem3].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('figure').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });

          let slideItem4 = document.querySelectorAll('.js-quote-sec--slider .slick-slide');

          [...slideItem4].forEach((e) => {
            if (e.getAttribute('aria-describedby')) {
              e.querySelector('p').setAttribute('id', e.getAttribute('aria-describedby'));
            }
          });
        }

        if (document.body.contains(document.querySelector('.page-template-vineyards'))) {
          let mapCntr = document.querySelector('.our-vineyards-sec');

          let img = document.querySelectorAll('.our-vineyards-sec img');

          [...img].forEach((e) => {
            let src = e.src;
            let filename = src.replace(/^.*[\\\/]/, '').split('.')[0];

            e.alt = filename;
          });

          let modalImages = document.querySelectorAll('.squares-container img');
          [...modalImages].forEach((e) => {
            let src = e.src;
            let filename = src.replace(/^.*[\\\/]/, '').split('.')[0];

            e.alt = filename;
          });

          let emptyBtns = document.querySelectorAll('.image-map button');
          [...emptyBtns].forEach((e) => {
            e.insertAdjacentHTML('afterbegin', '<span class="ada-span">Map Closer Button</span>');
          });
        }

        if (document.body.contains(document.querySelector('.page-template-events')) || document.body.contains(document.querySelector('.page-template-community'))) {
          let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
          let quantityLabelEl = `<p class="ada-label">Quantity</p>`;
          [...addToCart].forEach((e) => {
            e.querySelector('label').ariaLabel = 'quantity';
            e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
          });
        }

        if (
          document.body.contains(document.querySelector('.page-template-community')) ||
          document.body.contains(document.querySelector('.post-type-archive')) ||
          document.body.contains(document.querySelector('.wine101-template-default')) ||
          document.body.contains(document.querySelector('.recipes-template-default'))
        ) {
          let recipeCards = document.querySelectorAll('.recipe-card');

          [...recipeCards].forEach((e) => {
            let title = e.querySelector('.recipe-card__content a').innerText;
            e.querySelector('.recipe-card__image img').alt = `${title} hero image`;
          });
        }
      }, 3000);
    });
  },
  sierraPopup: function () {
    // general Popup

    setTimeout(() => {
      if (!document.body.contains(document.querySelector('.single-experiences.postid-601'))) return;
      if (!document.body.contains(document.querySelector('.rmbr.popup.general-notification'))) return;

      $('.rmbr.popup.general-notification').addClass('popup--opn');
      $('body').css({ overflow: 'hidden' });

      $('.popup__overlay, .safety-popup__close').on('click', function () {
        $('.rmbr.popup').removeClass('popup--opn');
        $('body').css({ overflow: 'visible' });
      });
    }, 4000);
  },
  giftMessageLimit: function () {
    // setTimeout(() => {
    let giftFlag = false;
    if (!document.body.contains(document.querySelector('.page-template-checkout'))) return false;

    // Select the parent element where the dynamically-added element will be added
    const parentElement = document.querySelector('.page-template-checkout #c7-checkout');
    let giftEl = document.querySelector('.page-template-checkout #c7-checkout textarea[name="giftMessage"]');

    // let interval = setInterval(function() {
    if (giftEl && giftEl.getAttribute('maxlength') !== '138') {
      giftEl.setAttribute('maxlength', '138');
      document.querySelector('label[id*="giftMessage-label"]').innerText = ' (Optional - 138 characters max)';
      clearInterval(interval);
    }
    //  }, 250);

    // Create a mutation observer to monitor the parent element for changes
    // const observer = new MutationObserver((mutations) => {
    //   // Check if the desired element has been added to the page
    //   mutations.forEach((mutation) => {
    //     console.log(mutation.target.id);

    //     // if (mutation.target.id === 'c7-checkboxisGiftMessage-true') {
    //     //   if (!giftFlag) {
    //     //     console.log('outside The c7-giftMessage was clicked');
    //     //     giftFlag = true;
    //     //     document.querySelector('#c7-giftMessage').setAttribute('maxlength', '138');
    //     //     document.querySelector('label[for="c7-:rc:-giftMessage"]').innerText = ' (optional - 138 characters max)';

    //     //     setTimeout(() => {
    //     //       giftFlag = false;
    //     //     }, 2000);
    //     //   }
    //     // }
    //   });
    // });

    // let config = { attributes: true, childList: true, subtree: true };
    // // Start observing the parent element for changes
    // observer.observe(parentElement, config);
    // }, 1500);
  },
  v2Updates: function () {
    // if (!window.c7v2) return;

    $(window).on('load', function () {
      setTimeout(() => {
        //shop all
        if (document.body.contains(document.querySelector('.page-template-shop-with-filer'))) {
          // Select the parent element where the dynamically-added element will be added
          const parentElement = document.querySelector('.shop-prdt-listing__wrap');

          const observer = new MutationObserver((mutations) => {
            // Check if the desired element has been added to the page
            mutations.forEach((mutation) => {
              if (mutation.addedNodes[0].className === 'c7-product-collection__product-list') {
                let wrappingEl = document.querySelector('.c7-product-collection__product-list');

                if (wrappingEl) {
                  wrappingEl.replaceWith(...wrappingEl.children);
                }

                observer.disconnect();
              }
            });
          });

          let config = { childList: true, subtree: true };
          // Start observing the parent element for changes
          observer.observe(parentElement, config);
        }

        if (document.body.contains(document.querySelector('div[data-collection-slug]'))) {
          let collectionSliders = document.querySelectorAll('div[data-collection-slug]');

          [...collectionSliders].forEach((e) => {
            // Select the parent element where the dynamically-added element will be added
            const parentElement = e;

            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type == 'childList') {
                  mutation.addedNodes.forEach((addedNode) => {
                    // Handle c7-product-collection__product-list
                    if (addedNode.nodeType === 1 && addedNode.classList.contains('c7-product-collection__product-list')) {
                      let wrappingEl = document.querySelector('.c7-product-collection__product-list');

                      if (wrappingEl) {
                        wrappingEl.replaceWith(...wrappingEl.children);
                      }
                    }

                    // Handle product-card with c7-product__add-to-cart
                    if (addedNode.nodeType === 1 && addedNode.classList.contains('product-card')) {
                      const addToCartElement = addedNode.querySelector('.c7-product__add-to-cart');

                      if (addToCartElement) {
                        // Initialize the slider once the .c7-product__add-to-cart class exists
                        initializeSlider();
                        observer.disconnect(); // Stop observing once the slider is initialized
                      }
                    }
                  });
                }
              });
            });

            let config = { childList: true, subtree: true };
            // Start observing the parent element for changes
            observer.observe(parentElement, config);
          });

          function initializeSlider() {
            let sliderOptions = {
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: true,
              responsive: [
                {
                  breakpoint: 1199,
                  settings: {
                    infinite: false,
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 991,
                  settings: {
                    infinite: false,
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    infinite: false,
                    slidesToShow: 1,
                  },
                },
              ],
            };

            // Add parentheses to variant price titles and create bottle shadows
            $('.rmbr.product-card.product-card--pc-slider').each(function () {
              // Add parentheses to variant price titles (if not already present)
              $(this)
                .find('.c7-product__variant__price__title')
                .each(function () {
                  let text = $(this).text().trim();
                  if (!text.startsWith('(') || !text.endsWith(')')) {
                    text = text.replace(/^\(+|\)+$/g, ''); // Remove any existing parentheses
                    $(this).text(`(${text})`);
                  }
                });

              // Create bottle shadow
              const figure = $(this).find('figure');
              const img = figure.find('img');

              if (figure.length && img.length && !figure.find('.product-shadow-image').length) {
                const shadowImg = $('<img>', {
                  src: img.attr('src'),
                  alt: '',
                  class: 'product-shadow-image',
                });

                figure.css('position', 'relative').prepend(shadowImg);
              }
            });

            $('.js-product-sliderHome1').on('afterChange', function (event, slick, currentSlide, nextSlide) {
              let addToCart = document.querySelectorAll('.c7-product__variant__add-to-cart');
              let quantityLabelEl = `<p class="ada-label">Quantity</p>`;
              [...addToCart].forEach((e) => {
                e.querySelector('label').ariaLabel = 'quantity';
                e.querySelector('label').insertAdjacentHTML('beforeend', quantityLabelEl);
              });

              let slideItem = document.querySelectorAll('.js-feedSlider .feed-item');

              [...slideItem].forEach((e) => {
                e.removeAttribute('aria-describedby');
              });
            });

            $('.js-product-sliderHome1').slick(sliderOptions);
          }
        }

        //ex. white wine collection page
        if (document.body.contains(document.querySelector('div[class*="collection-c7-content"]'))) {
          let url = new URL(window.location.href);
          if (url.pathname.includes('shop-all-wines')) return;

          const parentElement = document.querySelector('#c7-content');

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.target.classList.contains('prd-collection__list')) {
                let wrappingEl = document.querySelector('.prd-collection__list');

                if (wrappingEl) {
                  wrappingEl.replaceWith(...wrappingEl.children);
                }

                let wrappingC7Collection = document.querySelector('.c7-product-collection');

                if (wrappingC7Collection) {
                  wrappingC7Collection.replaceWith(...wrappingC7Collection.children);
                }

                let wrappingElInner = document.querySelector('.c7-product-collection__product-list');

                if (wrappingElInner) {
                  wrappingElInner.replaceWith(...wrappingElInner.children);
                }
              }
            });
          });

          let config = { childList: true, subtree: true };
          observer.observe(parentElement, config);

          parentElement.addEventListener('click', (event) => {
            if (event.target.closest('.shop-prdt-listing__item a')) {
              event.stopPropagation();
              event.stopImmediatePropagation();
              window.location.href = event.target.closest('.shop-prdt-listing__item a').href;
            }
          });
        }

        //landing page variant
        if (document.body.contains(document.querySelector('.c7-product-collection.--landing-variant'))) {
          // Select the parent element where the dynamically-added element will be added
          const parentElement = document.querySelector('.shop-prdt-listing__wrap');

          const observer = new MutationObserver((mutations) => {
            // Check if the desired element has been added to the page
            mutations.forEach((mutation) => {
              if (mutation.addedNodes[0].className === 'c7-product-collection__product-list') {
                let wrappingEl = document.querySelector('.c7-product-collection__product-list');

                if (wrappingEl) {
                  wrappingEl.replaceWith(...wrappingEl.children);
                }

                observer.disconnect();
              }
            });
          });

          let config = { childList: true, subtree: true };
          // Start observing the parent element for changes
          observer.observe(parentElement, config);
        }
      }, 500);
    });
  },
  restorePage: false,
  restoreCollectionBackArrow: function () {
    const collectionElement = document.querySelector('.c7-product-collection');
    if (collectionElement && !App.restorePage) {
      App.restorePage = true;
      window.location.reload();
      //console.log('messed up page', collectionElement);
    }
  },
  stopDoubleClubSignup: function () {
    if (document.body.contains(document.querySelector('.page-template-wine-clubs'))) {
      if (window.c7User == null) {
        let C7tenant = window.stagingC7 ? 'staging-rombauer' : 'rombauer-vineyards';

        let customerToken = Cookies.get('customerToken');

        if (typeof customerToken == 'undefined') {
          localStorage.setItem('loginStatus', null);
          window.c7User = null;
          return;
        }
        //console.log('customerToken', Cookies.get('customerToken'));

        fetch(`https://api.commerce7.com/v1/customer/self`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            tenant: C7tenant,
            authorization: customerToken,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.id !== null) {
              window.c7User = data;
              localStorage.setItem('loginStatus', 'loggedIn');
            }
          });
      } //window.c7User

      if (window.c7User !== null) {
        let userClubsArray = window.c7User.clubs;
        let clubsMap = [
          { clubTitle: 'Chardonnay Club – 4 bottles', clubID: 'b9076650-a1c1-497c-a92d-8c8f859af555' },
          { clubTitle: 'Chardonnay Club – 12 bottles', clubID: '91196d6c-05ac-494c-99df-c09e5ce58666' },
          { clubTitle: 'Zinfandel Club', clubID: '229a1d7f-2421-44fc-be1f-03f5224003fc' },
          { clubTitle: 'Classic Club', clubID: '2aeb2e8b-b446-4a80-9630-b49c0a522873' },
          { clubTitle: "Koerner's Cabernet Club", clubID: '1a3dce5e-61e6-43d0-b144-2d9809620b61' },
          { clubTitle: "Joan's Dessert Club", clubID: 'b0314f87-78ec-4b41-bb46-b32aa17fcf78' },
          { clubTitle: 'Rombauer On Demand', clubID: '5513098f-a258-4627-9667-5237f351315c' },
        ];

        function getClubTitle(clubID) {
          let club = clubsMap.find((club) => club.clubID === clubID);

          if (club) {
            return club.clubTitle;
            // Output: "Koerner's Cabernet Club"
          } else {
            return null;
          }
        }

        userClubsArray.forEach(function (club) {
          if (club.cancelDate == null) {
            let clubTitle = getClubTitle(club.clubId);
            let clubSlidesTitles = document.querySelectorAll('.js-tabSliderPane .slide-item .slide-item__details .details-top h4');

            clubSlidesTitles.forEach(function (clubSlideTitle) {
              if (clubSlideTitle.innerHTML === clubTitle) {
                let clubSlide = clubSlideTitle.closest('.slide-item');
                let clubSlideButton = clubSlide.querySelector('.slide-item__details a.rmbr.btn.btn--with-arrow');
                clubSlideButton.classList.add('c7-club-member');
                clubSlideButton.innerHTML = 'Edit Club Details';
                clubSlideButton.href = '/profile/club-membership';
              }
            });
          }
        });
      }
    }
  },
  addArrowToNewsletter: function () {
    const checkForm = setInterval(() => {
      const form = document.querySelector('[data-testid="klaviyo-form-TLitwz"]');
      if (form) {
        clearInterval(checkForm);
        const subscribeButton = form.querySelector('.go3894874857');
        if (subscribeButton) {
          const picture = document.createElement('picture');
          const source = document.createElement('source');
          source.setAttribute('media', '(max-width:1198px)');
          source.setAttribute('srcset', '/wp-content/themes/affinity-custom-webpack/assets/svg/arrow-blue-icon.svg');
          const img = document.createElement('img');
          img.setAttribute('src', '/wp-content/themes/affinity-custom-webpack/assets/svg/arrow-white-icon.svg');
          img.setAttribute('alt', '');
          picture.appendChild(source);
          picture.appendChild(img);
          subscribeButton.appendChild(picture);
        }
      }
    }, 300);
  },
  addStylesNewsletterInterior: function () {
    let count = 0;

    const checkForm = setInterval(() => {
      const form = document.querySelector('[data-testid="klaviyo-form-WKkTn9"]');
      if (form) {
        clearInterval(checkForm);
        const subscribeButton = form.querySelector('.go1888937926');
        if (subscribeButton) {
          subscribeButton.classList.add('rmbr', 'btn', 'btn--with-arrow');
        }
      } else if (++count === 20) {
        clearInterval(checkForm);
        console.log('Element not found after 20 checks.');
      }
    }, 300);
  },
  contactMap: function () {
    if (!document.body.contains(document.querySelector('.page-template-contact_2023'))) return false;

    function initializeMap() {
      const options = {
        /* todo */
      };

      const mapStyles = [
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#414a69',
            },
            {
              'lightness': '60',
            },
            {
              'saturation': '-10',
            },
            {
              'gamma': '1',
            },
          ],
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified',
            },
            {
              'saturation': '-57',
            },
            {
              'lightness': '75',
            },
            {
              'hue': '#005bff',
            },
          ],
        },
        {
          'featureType': 'landscape.natural.terrain',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'landscape.natural.terrain',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#003087',
            },
            {
              'saturation': '-50',
            },
            {
              'visibility': 'simplified',
            },
            {
              'lightness': '52',
            },
            {
              'weight': '1',
            },
          ],
        },
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'all',
          'stylers': [
            {
              'saturation': '-61',
            },
            {
              'hue': '#005bff',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'labels.text',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified',
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'visibility': 'on',
            },
            {
              'hue': '#005bff',
            },
            {
              'lightness': '79',
            },
            {
              'weight': '.5',
            },
          ],
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [
            {
              'color': '#dde1e9',
            },
            {
              'visibility': 'on',
            },
          ],
        },
      ];

      const loader = new Loader('AIzaSyDJ3ObA1kQE9V0LwwDgda6gdRU0o2HuEUE', options);
      let markers = [];
      let map;

      loader.load().then(function (google) {
        map = new google.maps.Map(document.getElementById('winery-location-map'), {
          center: { lat: 38.44671, lng: -121.582296 },
          // zoom: 9,
          styles: mapStyles,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        });

        let markerNV = new google.maps.Marker({
          position: { lat: 38.546038, lng: -122.492805 },
          map: map,
          title: 'Rombauer Vineyards,\nNapa Valley',
          label: {
            text: 'Rombauer Vineyards,\nNapa Valley',
            color: '#000',
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            className: 'marker-position',
          },
          icon: {
            url: '/wp-content/themes/affinity-custom-webpack/assets/images/maps/pin.png',
            scaledSize: new google.maps.Size(25, 35),
            labelOrigin: new google.maps.Point(9, 50),
          },
        });

        google.maps.event.addListener(markerNV, 'click', function () {
          window.location.href = 'https://goo.gl/maps/rULwQfxnRCTH834M9';
        });

        markers.push(markerNV);

        let markerSF = new google.maps.Marker({
          position: { lat: 38.541745, lng: -120.795241 },
          map: map,
          title: 'Rombauer Vineyards,\nSierra Foothills',
          label: {
            text: 'Rombauer Vineyards,\nSierra Foothills',
            color: '#000',
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            className: 'marker-position',
          },
          icon: {
            url: '/wp-content/themes/affinity-custom-webpack/assets/images/maps/pin.png',
            scaledSize: new google.maps.Size(25, 35),
            labelOrigin: new google.maps.Point(9, 50),
          },
        });

        google.maps.event.addListener(markerSF, 'click', function () {
          window.location.href = 'https://goo.gl/maps/N2XAUx1RJQ3k1sbV9';
        });

        markers.push(markerSF);

        function getZoomLevel() {
          ScrollTrigger.matchMedia({
            // large
            '(min-width: 992px)': function () {
              map.setZoom(9);
            },

            // small
            '(max-width: 991px)': function () {
              map.setZoom(7);
            },

            // all
            all: function () {
              // ScrollTriggers created here aren't associated with a particular media query,
              // so they persist.
            },
          });
        }

        getZoomLevel();
      });
    }
    initializeMap();
  },
  checkoutShopUpdate: function () {
    desktopButton();
    mobileButton();

    function desktopButton() {
      // select the 'returnToShop' link if it exists
      let existingLink = document.querySelector('.returnToShop--desktop');

      // only create and insert the new link if it does not already exist
      if (!existingLink) {
        // create a new link element
        let newLink = document.createElement('a');

        // set the class of the new element
        newLink.className = 'returnToShop--desktop';

        // set the href of the new link
        newLink.href = '/shop-all-wines/';

        // set the text of the new link
        newLink.innerText = 'Return to Shop';

        // select the parent element
        let parentElement = document.querySelector('.c7-checkout__header');

        // select the 'a' link element
        let anchorElement = document.querySelector('.c7-checkout__header a');

        // insert the new link after the 'a' link element, but before the 'nav' element
        parentElement.insertBefore(newLink, anchorElement.nextSibling);
      }
    }

    function mobileButton() {
      // select the 'returnToShop' link if it exists
      let existingLink = document.querySelector('.returnToShop--mobile');

      // only create and insert the new link if it does not already exist
      if (!existingLink) {
        // create a new link element
        let newLink = document.createElement('a');

        // set the class of the new element
        newLink.className = 'returnToShop--mobile';

        // set the href of the new link
        newLink.href = '/shop-all-wines/';

        // set the text of the new link
        newLink.innerText = 'Return to Shop';

        // select the parent element
        let parentElement = document.querySelector('.c7-checkout__header--mobile');

        // select the 'a' link element
        let anchorElement = document.querySelector('.c7-checkout__header--mobile a');

        // insert the new link after the 'a' link element, but before the 'nav' element
        parentElement.insertBefore(newLink, anchorElement.nextSibling);
      }
    }

    function adjustProductTitles() {
      // Function to process and update the title
      function processUpsellTitle(titleElement) {
        let titleText = titleElement.textContent; // Get the current text content of the title element

        if (titleText.includes('|')) {
          let processedTitle = titleText.split('|')[1].trim(); // Split the title at '|' and trim
          titleElement.textContent = processedTitle; // Update the text content of the title element
        }
      }

      // Select all elements with the class '.c7-order-item__title'
      let upsellTitles = document.querySelectorAll('.c7-order-item__title');

      // Iterate over each title element and process it
      upsellTitles.forEach((titleElement) => {
        processUpsellTitle(titleElement);
      });
    }

    adjustProductTitles();
  },
  oneTrustPreferences: function () {
    // Select all elements with the specific href
    let prefCenterLinks = document.querySelectorAll('a[href="#preference-center"]');

    console.log(prefCenterLinks);

    // Iterate over each element
    prefCenterLinks.forEach(function (prefCenterLink) {
      prefCenterLink.addEventListener('click', function (e) {
        // Prevent the default action of the link
        e.preventDefault();

        // Select the target button
        let otSdkBtn = document.getElementById('ot-sdk-btn');

        // Check if the button exists
        if (otSdkBtn) {
          // Programmatically trigger a click on the button
          otSdkBtn.click();
        } else {
          console.error('Element with id "ot-sdk-btn" not found.');
        }
      });
    });
  },
  removePipe: function () {
    // Select all elements that have 'title' in their class name
    let titleElements = document.querySelectorAll('[class*="title"]');

    titleElements.forEach((element) => {
      // Process the element itself if it contains text
      if (element.textContent.includes('|')) {
        element.textContent = element.textContent.split('|').pop().trim();
      }

      // Also process any child elements that contain text
      let childTitles = element.querySelectorAll('[class*="title"]');
      childTitles.forEach((child) => {
        if (child.textContent.includes('|')) {
          child.textContent = child.textContent.split('|').pop().trim();
        }
      });
    });
  },
  observeCart: function () {
    // Select the target node (the element you want to observe)
    let targetNode = document.getElementById('c7-side-cart');

    // Check if the target node exists
    if (!targetNode) {
      console.warn('Target node for mutation observer not found');
      return;
    }

    // Define what to observe in the observer (config)
    // Here we are just interested in attributes, specifically the class attribute
    let configBravo = {
      attributes: true,
      attributeFilter: ['class'], // We're only interested in changes to the 'class' attribute
    };

    // Callback function to execute when mutations are observed
    let callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Check the presence of 'visible' class
          let isVisible = targetNode.classList.contains('c7-side-cart--visible');
          // Toggle the iframe display based on the presence of 'visible' class
          let iframeDisplay = isVisible ? 'none' : 'unset';
          document.getElementById('redchirp-iframe').style.display = iframeDisplay;
        }
      }
    };

    // Create an instance of MutationObserver with the callback
    let observerBravo = new MutationObserver(callback);

    // Start observing the target node
    observerBravo.observe(targetNode, configBravo);

    // Optionally, keep the observer in a global variable if needed to disconnect later
    window.myObserver = observer;
  },
  elDorado: function () {
    if (window.location.href.includes('product')) {
      const h2Elements = document.querySelectorAll('.pruduct-details-sec__title-sec h2');
      h2Elements.forEach((h2) => {
        if (h2.innerHTML.includes('El Dorado')) {
          h2.innerHTML = h2.innerHTML.replace('El Dorado', 'El&nbsp;Dorado');
        }
      });
    }
  },
  updateEmailPreferencesHelp: function () {
    const maxAttempts = 20; // Maximum number of attempts
    let attempts = 0;

    function checkAndUpdate() {
      // Check if the current URL ends with '/checkout/club/customer'
      if (window.location.pathname.endsWith('/checkout/club/customer')) {
        const helpElement = document.querySelector('.c7-checkout__content #c7-emailPreferences-subscribe-help');
        if (helpElement) {
          helpElement.innerHTML = 'By entering your email, you agree to our Privacy Policy. <a style="color:#3251ae" href="/privacy-notice">View our Privacy Policy</a> here.';
          console.log('Email preferences help text updated successfully.');
          return; // Exit the function if the update is successful
        }
      }

      // If the element wasn't found and we haven't reached max attempts, try again
      if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkAndUpdate, 500); // Check again after 500ms
      } else {
        console.log('Max attempts reached. Unable to update email preferences help text.');
      }
    }

    // Start the checking process
    checkAndUpdate();
  },
  init: function () {
    this.oneTrustPreferences();
    this.PDPSoldOut();
    this.shopSetSelectToOne();
    this.videoHomeLoop();
    ///  this.C7Club();
    this.C7Clubv2();
    // this.c7LimitClubCancel();
    this.c7FixBodyCheckout();
    this.ageGate();
    this.c7LoginCheck();
    this.c7LoginIcon();
    this.addArrowToNewsletter();
    this.addStylesNewsletterInterior();
    this.contactMap();
    this.observeCart();
    this.updateEmailPreferencesHelp();

    setTimeout(function () {
      App.stopDoubleClubSignup();
    }, 1000);

    let intervalId = setInterval(function () {
      let url = new URL(window.location);
      //check if club member
      if (url.pathname.includes('/profile/')) {
        App.c7LoginCheck();
        App.c7LoginIcon();
      }
      //add custom club terms on checkout
      if (url.pathname.includes('/checkout/club/')) {
        App.C7Clubv2();
      }
      //add custom club terms on checkout
      if (url.pathname.includes('/checkout/cart/delivery')) {
        App.giftMessageLimit();
      }

      if (url.pathname.includes('/checkout/cart/')) {
        App.checkoutShopUpdate();
      }
      App.removePipe();
      App.elDorado();
    }, 1000); // Check every 1000 milliseconds

    this.c7removeOptionsCollection();
    this.c7ResoRemoveZeros();
    this.homeTextSplits();
    this.homeCanvas();
    this.allocation();
    this.shippingChoice();
    this.updateShippingMethod();
    //  this.updateShippingMethodCheckout();
    this.sierraPopup();
    this.ada();

    this.v2Updates();
    Util.init();

    //this.restoreCollectionBackArrow();
    window.addEventListener('popstate', function (event) {
      App.restoreCollectionBackArrow();
    });

    this.initPopups();
  },
  // Replace the scattered popup handlers with a single unified approach
  initPopups: function () {
    // Handle safety popup triggers
    $(document).on('click', '.safety-popup-trigger', function (e) {
      e.preventDefault();
      const safetyPopup = document.querySelector('.rmbr.popup.safety-notification-wrapper');
      if (safetyPopup) {
        safetyPopup.classList.add('popup--opn');
        document.body.style.overflow = 'hidden';
      }
    });

    // Handle popup closures
    $(document).on('click', '.popup__overlay, .safety-popup__close', function () {
      const popup = $(this).closest('.rmbr.popup');
      popup.removeClass('popup--opn');
      document.body.style.overflow = 'visible';
    });

    // Handle ESC key
    $(document).keyup(function (e) {
      if (e.key === 'Escape') {
        $('.rmbr.popup').removeClass('popup--opn');
        document.body.style.overflow = 'visible';
      }
    });

    // Auto-show general notification popup if enabled
    setTimeout(() => {
      // Changed selector to match the actual HTML structure
      const generalPopup = document.querySelector('.rmbr.popup.general-notification');
      if (generalPopup) {
        generalPopup.classList.add('popup--opn');
        document.body.style.overflow = 'hidden';
      }
    }, 4000);

    // Auto-show safety notification popup if enabled
    setTimeout(() => {
      const safetyPopup = document.querySelector('.rmbr.popup.safety-notification-wrapper');
      if (safetyPopup && document.querySelector('[data-health-notification="yes"]')) {
        safetyPopup.classList.add('popup--opn');
        document.body.style.overflow = 'hidden';
      }
    }, 2500);
  },
  // Helper methods
  openPopup: function (popup) {
    popup.classList.add('popup--opn');
    document.body.style.overflow = 'hidden';
  },
  closePopup: function (popup) {
    popup.classList.remove('popup--opn');
    document.body.style.overflow = 'visible';
  },
};

export default App;
